module.exports = __webpack_public_path__ + "static/media/vanuatu.19bce6e2.svg";